import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import dumbBem from 'dumb-bem';
import tx from 'transform-props-with';

const dumbFooter = dumbBem('l-footer');
const Terms = tx([{ element: 'terms' }, dumbFooter])('div');
const Term = tx([{ element: 'term' }, dumbFooter])('div');

const FooterLinks = ({
  handleClick,
}) => {
  const onClick = event => {
    const type = get(event, 'currentTarget.dataset.type');
    handleClick(type);
  };

  return (
    <Terms>
      <Term onClick={onClick} data-type="terms">
        Terms
      </Term>

      <span>&nbsp;|&nbsp;</span>

      <Term onClick={onClick} data-type="privacy">
        Privacy
      </Term>
    </Terms>
  );
};

FooterLinks.propTypes = {
  handleClick: PropTypes.func.isRequired,
};

export default FooterLinks;



// WEBPACK FOOTER //
// ./src/components/landing/components/footer/FooterLinks.js